module.exports = __webpack_public_path__ + "static/media/country_gh.fc93edc3.webp";